const utils = require("utils");

let awards = 
[
	{
		name: "Brick of Validation",
		date: "May 2015",
		event: "SF \"Terrible Ideas\" Hackathon",
		className: "brick",
		image: utils.getAsset("awards/brick.svg"),
	},
	{
		name: "Computer Science Award",
		date: "May 2017",
		event: "George Washington High School",
		className: "csdept",
		image: utils.getAsset("awards/csdept.svg"),
	},
];

module.exports = awards;


// WEBPACK FOOTER //
// ./src/js/awards.js